/**
 * Created by idea on 03/07/2017.
 */
import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {RouterModule} from '@angular/router';
import {AdminFooterComponent} from './admin-footer.component';

@NgModule({
    declarations: [AdminFooterComponent],
    imports     : [BrowserModule, RouterModule],
    exports     : [AdminFooterComponent],
})

export class FooterModule {}



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/layout/footer/footer.module.ts